import {BaseContainerModel} from '../base-container.model';
import {bl_fi_mst_gl_dimension_RowClass} from '../../dbschema';

export class DimensionContainerModel extends BaseContainerModel {
  bl_fi_mst_gl_dimension: bl_fi_mst_gl_dimension_RowClass = new bl_fi_mst_gl_dimension_RowClass();
}
